import { useEffect, useState, useCallback } from 'react'
import { useSetRecoilState, useRecoilValue } from 'recoil'
import { companyInfoState, companyInfoSelector } from '../state'
import { allowMockApi, hiveApiUrl } from '../firebase'

export default function useCompanyInfo(reqParams) {
  const [loading, setLoading] = useState(false)
  const [fetchError, setFetchError] = useState(null)
  const setCompanyInfo = useSetRecoilState(companyInfoState)

  // eslint-disable-next-line no-undef
  const url = allowMockApi
    ? '/mock/company-info'
    : `${hiveApiUrl}/api/appointment/company-info?company=${reqParams.company}&resource=${reqParams.resource}`

  const fetchCompanyInfo = useCallback(async () => {
    setLoading(true)

    try {
      const res = await fetch(url)
      const json = await res.json()

      setCompanyInfo(json.data)

      setLoading(false)
    } catch (error) {
      setFetchError(error)
      setLoading(false)
    }
  }, [setLoading, setCompanyInfo, setFetchError])

  useEffect(() => {
    !fetchError && fetchCompanyInfo()
  }, [fetchCompanyInfo, fetchError])

  const { company, resource } = useRecoilValue(companyInfoSelector)

  return {
    company,
    resource,
    loading,
    fetchError,
  }
}
